import {documentToPlainTextString} from '@contentful/rich-text-plain-text-renderer'
import {Hero} from '@primer/react-brand/esm'

import {hpcAttrs} from '@github-ui/hpc'

import {useGenericCtaAction} from '../../../../../brand/components/GenericCtaAction/use-generic-cta-action'
import type {GenericContent} from '../../../../../brand/lib/types/contentful'

type Props = {
  contentfulContent: GenericContent
}

export function HeroIntro({contentfulContent}: Props) {
  const {heading, subheading, label} = contentfulContent.fields

  const ctaFields = contentfulContent.fields.cta?.fields
  const genericCtaFields = ctaFields && 'primary' in ctaFields ? ctaFields : undefined
  const primaryAction = useGenericCtaAction(genericCtaFields?.primary, {
    analytics: {tag: 'button', context: 'CTAs', location: 'hero'},
  })
  const secondaryAction = useGenericCtaAction(genericCtaFields?.secondary, {
    analytics: {tag: 'button', context: 'CTAs', location: 'hero'},
  })

  return (
    <>
      <Hero {...hpcAttrs()} variant="gridline-expressive" data-center-on-tablet>
        {label ? <Hero.Label>{label.fields.text}</Hero.Label> : null}
        {heading ? <Hero.Heading>{heading}</Hero.Heading> : null}

        {subheading ? <Hero.Description>{documentToPlainTextString(subheading)}</Hero.Description> : null}

        <Hero.ButtonGroup>
          {primaryAction.action}
          {secondaryAction.action}
        </Hero.ButtonGroup>
      </Hero>

      {primaryAction.feedback}
      {secondaryAction.feedback}
    </>
  )
}
